export function isRateClosed(effectiveEndUtc: string | null | undefined): boolean {
  if (!effectiveEndUtc) {
    return false;
  }
  return new Date(effectiveEndUtc) < new Date();
}
